import { AppLink } from 'types/AppLink';

import { ContentModel } from '../ContentModel';

export interface ContentNavigationSingle extends ContentModel {
  title: string;
  intro: string | null;
  link: AppLink | null;
  type: 'single';
}

export interface ContentNavigationMultiple extends ContentModel {
  title: string;
  links: AppLink[];
  type: 'multiple';
}

export const isContentNavigationSingle = (
  item: ContentNavigationSingle | ContentNavigationMultiple
): item is ContentNavigationSingle => item.type === 'single';
